<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filtres</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <!-- project state filter start -->
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Offre</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="stateFilter"
            :options="stateOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:stateFilter', val)"
            :disabled="statusFilter != null"
          />
        </b-col>
        <!-- project state filter end -->
        <!-- type filter start -->
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Type</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="typeFilter"
            :options="typeOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:typeFilter', val)"
          />
        </b-col>
        <!-- type filter end -->
        <!-- status filter start -->
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Status</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="(val) => val.key"
            @input="(val) => $emit('update:statusFilter', val)"
            :disabled="stateFilter != null"
          />
        </b-col>
        <!-- status filter end -->
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    stateFilter: {
      type: [String, null],
      default: null,
    },
    typeFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    typeOptions: {
      type: Array,
      required: true,
    },
    stateOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
